import { getField, updateField } from 'vuex-map-fields';

const getters = {
    getField,

    getCurrentFilters(state) {
        return state.currentFilters;
    }
};

const state = {
    currentFilters: [],
    itemsPerResult: 20,
    page: 1
};

const mutations = {
    updateField,

    setCurrentFilters(state, newFilters) {
        state.currentFilters = newFilters
    },
    setCurrentFilterByName(state, param) {
        state.currentFilters[param.filterName] = param.filterVal
    },
    resetPage(state) {
        state.page = 1
    },
    incrementPage(state) {
        state.page += 1;
    },
    setPage(state, page) {
        state.page = page;
    }
};

const actions = {
    setFilters({state,commit,dispatch}, param) {
        commit('setCurrentFilters', param);
        commit('resetPage');
        dispatch('updateUrl');
    },
    updateFiltersByName({state,commit,dispatch}, param) {
        commit('setCurrentFilterByName', param);
        commit('resetPage');
        dispatch('updateUrl')
    },
    updateUrl({state}) {
        var queryString = "?";
        Object.keys(state.currentFilters).forEach((filterName,i) => {
            if (!state.currentFilters[filterName] || state.currentFilters[filterName].length === 0) {
                return true;
            }
            queryString += `${i > 0 ? '&' : ''}${filterName}=${state.currentFilters[filterName] instanceof Array ? state.currentFilters[filterName].map(f => encodeURIComponent(f)).join(',') : encodeURIComponent(state.currentFilters[filterName])}`
        });
        window.history.replaceState({},'', encodeURI(queryString))
    },
    resetFilters({state,commit,dispatch}) {
        commit('resetPage');
        Object.keys(state.currentFilters).forEach(filterName => {
            var variableType = state.currentFilters[filterName] ? new window[ state.currentFilters[filterName].constructor.name ] : null;
            dispatch('updateFiltersByName', {filterName: filterName, filterVal: variableType})
        });
        dispatch('updateUrl')
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};